import React from 'react';
import TabHeader from '../common/TabHeader';
import { Grid, Typography } from '@material-ui/core';
import ProductDetails from '../Product/ProductDetails';
import { get } from 'lodash';
import { productJsonProps } from '../../Constants/Products';
import { getProductUpdatedTime } from '../../Utils/ProductUtils';
import ProductRefreshBtn from './ProductRefreshBtn';

const title = 'PRODUCT Data';
const explanation = 'We retrieve product information from bifrost, it is automatically refreshed daily.';

const PCMDataTab = (product) => {
	const productId = get(product, productJsonProps.productId);
	const productUUID = product?.id;

	const actions = [
		<Grid container item alignItems="flex-end" spacing={2}>
			<Grid item>
				<Typography variant="subtitle1">{'Last Updated: '}</Typography>
				<Typography color="textSecondary" variant="body1">
					{getProductUpdatedTime(product)}
				</Typography>
			</Grid>
			<Grid item>
				<ProductRefreshBtn productId={productId} productUUID={productUUID} />
			</Grid>
		</Grid>,
	];
	return (
		<Grid container direction="column" spacing={4}>
			<Grid item>
				<TabHeader title={title} explanation={explanation} actions={actions} />
			</Grid>
			<Grid item>
				{/* Adding isListLayout to true for PRODUCT DATA tab which renders on manage product details page.
				since we have more real estate to display it in the list view. */}
				<ProductDetails product={product} isListLayout={true} isFromManageProduct={true} />
			</Grid>
		</Grid>
	);
};

export default PCMDataTab;
